export default class Broker {
    constructor() {
        this.id;
        this.name;
        this.comissionRate;
        this.contractFileId;
        this.brokerFirmId;

        this.customerIds = [];
        this.customerCompanyIds = [];
        this.brokerNotes = [];
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.name = setEntity.name;
        this.comissionRate = setEntity.comissionRate;
        this.contractFileId = setEntity.contractFileId;
        this.brokerFirmId = setEntity.brokerFirmId;

        this.customerIds = setEntity.customerIds ? setEntity.customerIds : [];
        this.customerCompanyIds = setEntity.customerCompanyIds ? setEntity.customerCompanyIds : [];
        this.brokerNotes = setEntity.brokerNotes ? setEntity.brokerNotes : [];
        return this;
    }
}